// Every board is a fixed 960×540, and Saga's text is as long as Saga makes
// it. The deck partials size type for the text they expect and split long
// lists across boards; this is the net under both. A `.deck-fit` box whose
// `.deck-fit-body` spills past it has that body zoomed down, one step at a
// time, until it fits — but never below the deck's 12px type floor at the
// 960 reference. Zoom rather than font-size, so every inline size in the
// body scales together, and the body is widened to match so the text reflows
// into the room instead of shrinking into a narrower column.
//
// Built as its own bundle too, so the PDF layout — which loads no app
// JavaScript — fits its boards before they print.

const TYPE_FLOOR = 12;
const STEP = 0.04;

function smallestType(body) {
  let smallest = Infinity;
  const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (!node.textContent.trim() || !node.parentElement) continue;
    smallest = Math.min(smallest, parseFloat(getComputedStyle(node.parentElement).fontSize));
  }
  return smallest;
}

function spills(box) {
  return box.scrollHeight > box.clientHeight + 1 || box.scrollWidth > box.clientWidth + 1;
}

function fit(box) {
  const body = box.querySelector(":scope > .deck-fit-body");
  if (!body) return;

  body.style.zoom = "";
  body.style.width = "";
  if (!spills(box)) return;

  const floor = Math.min(1, TYPE_FLOOR / smallestType(body));
  let zoom = 1;
  while (spills(box) && zoom - STEP >= floor) {
    zoom -= STEP;
    body.style.zoom = zoom.toFixed(3);
    body.style.width = `${(100 / zoom).toFixed(3)}%`;
  }
}

export function fitDeck(root = document) {
  root.querySelectorAll(".deck-fit").forEach(fit);
}

function fitWhenReady() {
  fitDeck();
  // Metrics change when the deck's face arrives; fit again against it.
  document.fonts?.ready.then(() => fitDeck());
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", fitWhenReady, { once: true });
} else {
  fitWhenReady();
}
document.addEventListener("turbo:load", fitWhenReady);
